import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Moment from 'react-moment';
import moment from 'moment';

const ProfileAbout = ({
  profile: {
    bio,
    skills,
    location,
    relationship,
    user: { date }
  }
}) => (
  <Fragment>
    <div className="card-body pb-2">
      <div className="about">
        <h6 className="d-inline ml-1">About</h6>
        {location && (
          <dl className="row mb-0 mt-1 mx-0 text-muted">
            <dt className="col-1">
              <i className="fas fa-home"></i>
            </dt>
            <dd className="col-10 mb-1 pl-2">
              <p className="text-muted mb-0">{location}</p>
            </dd>
          </dl>
        )}
        {relationship && (
          <dl className="row m-0 text-muted">
            <dt className="col-1">
              <i className="fas fa-heart heart"></i>
            </dt>
            <dd className="col-10 mb-1 pl-2">
              <p className="text-muted mb-0">{relationship}</p>
            </dd>
          </dl>
        )}
        <dl className="row mb-1 mx-0 text-muted">
          <dt className="col-1">
            <i className="far fa-calendar-alt"></i>
          </dt>
          <dd className="col-10 mb-0 pl-2">
            <p className="text-muted mb-0">
              Joined <Moment format="LL">{date}</Moment>
            </p>
          </dd>
        </dl>
      </div>
    </div>
  </Fragment>
);

ProfileAbout.propTypes = {
  profile: PropTypes.object.isRequired
};

export default ProfileAbout;
